import { render } from "./DemandForecastingContent.vue?vue&type=template&id=1a713023&scoped=true"
import script from "./DemandForecastingContent.vue?vue&type=script&lang=js"
export * from "./DemandForecastingContent.vue?vue&type=script&lang=js"

import "./DemandForecastingContent.vue?vue&type=style&index=0&id=1a713023&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1a713023"]])

export default __exports__